import { PermissionType } from '@golden/gdk-admin'
import LinkType from '../../default/navigation/LinkType'
import TKeyType from '../../../i18ns/admin/TKeyType'
import RoutePermission from '../route/RoutePermission'
import { goldenURL } from '@golden/url'

export enum LinkKey {
  BATTLE_FIELD = 'battleField',
  BATTLE_FIELD_NEXT = 'battleFieldNext',
  OPEN_IM_ADMIN = 'openIMAdmin',
  LIVE_CONTROL_ADMIN = 'liveControlAdmin'
}

const stage = import.meta.env.VITE_APP_STAGE
const url = import.meta.env.VITE_APP_URL
const csUrl = goldenURL(stage === 'local' ? url : undefined, 'https:').get('bfAdmin')
const battleFieldNextUrl = goldenURL(stage === 'local' ? url : undefined, 'https:').get('main')
const openIMUrl = goldenURL(stage === 'local' ? url : undefined, 'https:').get('openIMAdmin')
const liveControlAdminUrl = goldenURL(stage === 'local' ? url : undefined, 'https:').get('main')
const link: {
  [key in LinkKey]: LinkType<LinkKey, RoutePermission, TKeyType>
} = {
  [LinkKey.BATTLE_FIELD]: {
    key: LinkKey.BATTLE_FIELD,
    title: 'page.csChat',
    href: `${csUrl}/case`,
    blank: true,
    permissions: [
      { type: 'accessible', value: PermissionType.CUSTOMER_SERVICE_READ }
    ]
  },
  [LinkKey.BATTLE_FIELD_NEXT]: {
    key: LinkKey.BATTLE_FIELD_NEXT,
    title: 'topNav.newCustomerService',
    href: `${battleFieldNextUrl}/bf-next/`,
    blank: true,
    permissions: [
      { type: 'accessible', value: PermissionType.CUSTOMER_SERVICE_READ }
    ]
  },
  [LinkKey.OPEN_IM_ADMIN]: {
    key: LinkKey.OPEN_IM_ADMIN,
    title: '',
    href: `${openIMUrl}/login`,
    blank: true,
    permissions: []
  },
  [LinkKey.LIVE_CONTROL_ADMIN]: {
    key: LinkKey.LIVE_CONTROL_ADMIN,
    title: 'common.liveControlAdmin',
    href: `${liveControlAdminUrl}/live-control-admin/sso`,
    blank: true,
    permissions: []
  }
}

export default link
